<template>
    <van-popup
            v-if="selectProductInPopupShow" v-model="selectProductInPopupShow" z-index="100" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">

        <div class="product_in_wrap" v-loading="loading">
            <div class="product_in_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose" >
                        <van-icon name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                    <div class="returnNavBarRight">
                        <van-search
                                v-model="searchForm.keyword"
                                placeholder="请输入产品名称"
                                @clear="handleClickSearch"
                                @search="handleClickSearch">
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="selectBrandPopupShow = true"></i>
                            </template>
                        </van-search>
                    </div>
                </div>
                <div class="category_wrap">
                    <div class="category_top" @click="categoryShow = !categoryShow">
                        <span class="ellipsis" v-text="searchForm.category_name"></span> <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div class="category_bottom" v-show="categoryShow" :class="{'noActiveTree':searchForm.category_id == ''}">
                        <div class="category_item" :class="{'active':searchForm.category_id == ''}" @click="handleClickCategory({id:'',name:'全部产品'})" >
                            <p>全部产品</p>
                        </div>
                        <el-tree ref="cateGoryTreeRef"
                                 :data="categoryList"
                                 :draggable="true"
                                 :expand-on-click-node='false'
                                 :props="{children: 'children',label: 'name'}"
                                 check-on-click-node
                                 check-strictly
                                 default-expand-all
                                 node-key="id">
                            <div  class="custom_tree_node" slot-scope="{ node, data }"  @click="handleClickCategory(data)">
                                <div  class="node_label ellipsis">{{node.label }}</div>
                            </div>
                        </el-tree>
                    </div>
                </div>
            </div>

            <div class="product_in_bottom">
                <ul v-infinite-scroll="onLoadList">
                    <li v-for="item in  productListData">
                        <div class="product_cover">
                            <img :src="item.sku_image ? item.sku_image :'https://download.hecoos.com/enlightv/2024-48/01685fc00b3698f7a1b3d02d936e0e92.jpg' " alt=""/>
                        </div>
                        <div class="product_content">
                            <div class="left">
                                <p v-text="item.name"></p>
                                <span v-text="item.brand_name"></span>
                            </div>
                            <div class="right">
                                <span @click="handleClickSelectSku(item)">选择</span>
                            </div>
                        </div>
                    </li>
                </ul>

            </div>

            <div class="product_in_footer">
                <div class="product_in_footer_left" @click="selectProductShow = true">
                    <img src="https://download.hecoos.com/enlightv/2025-02/6301f0a93877e8a0b28fc7648a1c7b84.svg" alt="">
                    <span v-if="selectProductData.length" v-text="selectProductData.length"></span>
                    <p>已选</p>
                    <i class="el-icon-caret-top"></i>
                </div>
                <div class="product_in_footer_right">
                    <van-button type="info" size="normal" @click="handleClickConfirm" :disabled="BtnDisabled">提交</van-button>
                </div>
            </div>
        </div>

        <SelectBrand  :selectBrandPopupShow.sync="selectBrandPopupShow" v-if="selectBrandPopupShow" :selectedBrandId="searchForm.brand_id" @success="selectBrandSuccess"/>
        <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"  v-if="categoryShow" :show="categoryShow" @click="categoryShow = false"></van-overlay>
        <!--选择产品具体规格-->
        <van-popup v-model="productSkuShow" class="product_custom_popup" round overlay-class="product_custom_overlay" :style="{ height: '520px',width: '90%',zIndex:100000}"
                   :close-on-click-overlay="false" @click-overlay="handleClickCloseSku">
            <div class="product_sku_wrap" v-loading="itemLoading">
                <div class="product_sku_top">
                    <span>选择规格</span>
                    <van-icon name="cross" @click="handleClickCloseSku"/>
                </div>
                <div class="product_sku_content" v-if="productInfo">
                    <div class="field_item" v-for="spec in productInfo.specs">
                        <div class="field_name">{{spec.name}}：</div>
                        <div class="field_value" >
                            <span class="spec_value" :class="list.checked ? 'active' : ''" @click="handleClickSelected(spec,list)"  v-for="list in spec.values" v-text="list.value"></span>
                        </div>
                    </div>
                </div>
                <div class="product_sku_bottom" v-if="productInfo">
                    <p class="ellipsis_2" v-text="productInfo.specs_value.find(find => (find.checked && find.checked)) ? productInfo.specs_value.find(find => (find.checked && find.checked)).name : ''"></p>
                    <van-button type="info" size="small" @click="handleClickAdd"><van-icon name="plus" />加入已选项</van-button>
                </div>
            </div>
        </van-popup>

        <!--已选产品-->
        <van-popup v-model="selectProductShow" position="bottom" class="product_custom_popup" round overlay-class="product_custom_overlay" :style="{ height: '62vh',zIndex:100000}"
                   :close-on-click-overlay="false" @click-overlay="handleClickSelectProductClose">
            <div class="select_product_wrap" >
                <div class="select_product_top">
                    已选产品
                    <span @click="selectProductData = []"><i class="iconfont icon-shanchu1" ></i>清空</span>
                </div>
                <div class="select_product_content">
                    <ul>
                        <li v-for="(item,key) in selectProductData" :key="key">
                            <p v-text="item.name"></p>
                            <i @click="selectProductData.splice(key,1)" class="iconfont icon-guanbi_dise"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>



    </van-popup>

</template>

<script>
// 移动端是多选，pc端是单选，胡东阳说不会变
import { cloudCateList,cloudProductList,cloudProductDetail } from "@/api/index.js"
import {pagination} from '@/mixins'
import SelectBrand from "../component/select_brand"
import { Dialog } from 'vant';
export default {
    name: "select_product_in",
    components: {SelectBrand},
    props: {
        selectProductInPopupShow: {
            type: Boolean,
            default: false,
        },

    },
    data() {
        return {
            loading: false,
            BtnDisabled:false,
            searchForm:{
                keyword: '',
                category_id:'',
                brand_id:null,
                category_name:'全部产品'
            },
            selectBrandPopupShow:false,
            categoryShow:false,
            categoryList:[],
            productListData:[],
            productSkuShow:false,
            itemLoading:false,
            productInfo:null,
            selectProductData:[],
            selectProductShow:false,
        };
    },
    mixins: [pagination],
    created() {
        this.getCloudCateList()
    },
    methods: {
        // 选择品牌回调
        selectBrandSuccess(data){
            this.searchForm.brand_id = data.id
            this.handleClickSearch()
        },
        // 获取分组
        getCloudCateList(){
            this.loading = true;
            let postData = {}
            cloudCateList(postData).then(res => {
                if(res.code == 200){
                    this.categoryList = res.data
                    this.getTableData()
                }
            })

        },
        // 选择分组
        handleClickCategory(data){
            if(data.id == 0){
                this.$refs.cateGoryTreeRef.setCurrentKey();
            }
            this.searchForm.category_id = data.id
            this.searchForm.category_name = data.name
            this.categoryShow = false
            this.handleClickSearch()
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.productListData = []
            this.getTableData()
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.productListData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                category_id: this.searchForm.category_id,
                name: this.searchForm.keyword,
                brand_id: this.searchForm.brand_id
            }
            cloudProductList(postData).then(res => {
                if(res.code == 200){
                    let {data,total} = res.data
                    this.productListData = this.productListData.concat(data)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                }
                this.loading = false;
            })
        },

        handleClickSelectSku(item){
            this.productSkuShow = true
            this.getCloudProductDetail(item)
        },
        // 获取详情
        getCloudProductDetail(item,key){
            let postData = {
                id:item.id
            }
            this.itemLoading = true
            cloudProductDetail(postData).then(res => {
                if(res.code == 200){
                    let specs_value = []
                    res.data.skus.forEach((item)=>{
                        let json = {
                            name:item.name,
                            sku_id:item.id,
                            sku_key:item.sku_key,
                            sku_ids:item.specs.map(map => { return map.spec_value_id}).join(','),
                        }
                        specs_value.push(json)
                    })
                    this.$set(item,'specs_value',specs_value)
                    this.$set(item,'specs',res.data.specs)
                    this.productInfo = JSON.parse(JSON.stringify(item))
                    this.itemLoading = false
                }
            })
        },
        // 选择
        handleClickSelected(spec,list){
            spec.values.forEach(list => {
                this.$set(list,'checked',false)
            })
            this.$set(list,'checked',true)
            let specs_value = []
            this.productInfo.specs.forEach((specItem)=>{
                if(specItem.values){
                    specItem.values.forEach(valueItem => {
                        if(valueItem.checked){
                            specs_value.push(valueItem.id)
                        }
                    })
                }
            })
            let spec_values = specs_value.join(',')
            if(this.productInfo.specs_value){
                this.productInfo.specs_value.forEach(item => {
                    if(item.sku_ids == spec_values){
                        this.$set(item,'checked',true)
                    }else{
                        this.$set(item,'checked',false)
                    }
                })
            }
        },
        handleClickCloseSku(){
          this.productSkuShow = false
          this.productInfo = null
        },
        // 加入已选
        handleClickAdd(){
            let data = this.productInfo.specs_value.find(find => (find.checked && find.checked))
            if(data){
                data.unit = this.productInfo.unit
                this.selectProductData.push(data)
                this.productSkuShow = false
                this.productInfo = null
            }else{
                this.$toast('请选择规格')
            }
        },

        handleClickSelectProductClose(){
            this.selectProductShow = false
        },

        handleClickConfirm() {
            this.$emit("success", this.selectProductData)
            this.$emit("update:selectProductInPopupShow", false)

        },
        handleClickClose(){
            this.$emit("update:selectProductInPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.product_custom_popup{
    z-index: 1002 !important;
    border-radius: 8px;
}
::v-deep .product_custom_overlay{
    z-index: 1001 !important;
}
.product_in_wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    .product_in_top{
        width: 100%;
        border-bottom: 10px solid rgba(247, 248, 250, 1);
        box-sizing: border-box;
        position: relative;
        z-index: 1000;
        background: #fff;
        .returnNavBar{
            padding-top: 0;
            padding-bottom: 0;
            align-items: center;
        }
        .returnNavBarRight{
            width: 178px;
            flex: initial;
            .van-search{
                padding: 0;
               .van-cell{
                   padding-top: 4px;
                   padding-bottom: 4px;
               }
            }
            .icon-shaixuan{
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
            }
        }

        .category_wrap{
            width: 100%;
            height: 44px;
            position: relative;
            .category_top{
                padding: 0 16px;
                box-sizing: border-box;
                line-height: 44px;
                display: flex;
                align-items: center;
                i{
                    font-size: 14px;
                    margin-left: 4px;
                }
            }
            .category_bottom{
                width: 100%;
                position: absolute;
                left: 0;
                top: 44px;
                background: #fff;
                height: 258px;
                padding: 12px 0;
                box-sizing: border-box;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                .category_item{
                    line-height: 30px;
                    padding: 0 24px;
                    color: rgb(102, 102, 102);
                    &.active{
                        background:rgba(41, 144, 255, 0.16);
                        color: rgba(41, 144, 255, 1);
                        font-weight: bold;
                    }
                }
                ::v-deep .el-tree-node__content{
                    height: 30px;
                    opacity: 1;
                    border-radius: 6px;
                    &:hover{
                        background: rgba(0, 0, 0, 0.04);
                    }
                }
                ::v-deep .expanded.el-icon-caret-right{
                    color: rgba(102, 102, 102, 1);
                    font-size: 14px;
                }
                .custom_tree_node{
                    padding-right: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: calc(100% - 24px);
                    .node_label{
                        width: calc(100% - 36px);
                        color: rgba(102, 102, 102, 1);
                        font-size: 14px;
                    }
                }
                ::v-deep .el-tree-node.is-current > .el-tree-node__content{
                    background:rgba(41, 144, 255, 0.16);
                    .node_label{
                        color: rgba(41, 144, 255, 1);
                        font-weight: bold;

                    }
                }
                &.noActiveTree{
                    .el-tree-node.is-current > .el-tree-node__content{
                        background: transparent;
                        .node_label{
                            color: rgba(102, 102, 102, 1);
                            font-weight: 400;
                        }
                    }
                }
            }
        }
    }
    .product_in_bottom{
        flex: 1;
        overflow: auto;
        background: #fff;
        ul{
            width: 100%;
            li{
                padding: 12px 16px;
                border-bottom: 1px solid rgba(247, 248, 250, 1);
                box-sizing: border-box;
                display: flex;
                .product_cover{
                    width: 46px;
                    height: 46px;
                    img{
                        border-radius: 4px;
                        display: block;
                        width: 46px;
                        height: 46px;
                    }
                }
                .product_content{
                    width: calc(100% - 46px);
                    padding: 0 0 0 8px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .left{
                        width: calc(100% - 48px);
                        p{
                            margin-bottom: 2px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(0, 0, 0, 1);
                            font-weight: bold;
                        }
                        span{
                            display: inline-block;
                            padding: 0 8px;
                            height: 22px;
                            border-radius: 4px;
                            background: rgba(240, 170, 50, 0.1);
                            box-sizing: border-box;
                            color: rgba(240, 170, 50, 1);
                        }
                    }
                    .right{
                        width: 40px;
                        span{
                            width: 40px;
                            height: 24px;
                            opacity: 1;
                            border-radius: 4px;
                            background: rgba(255, 255, 255, 1);
                            border: 1px solid rgba(41, 144, 255, 1);
                            box-sizing: border-box;
                            line-height: 22px;
                            text-align: center;
                            color: rgba(41, 144, 255, 1);
                            font-size: 12px;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
    .product_in_footer{
        padding: 4px 16px;
        padding-bottom:calc(4px + env(safe-area-inset-bottom)) ;
        box-sizing: border-box;
        box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.04);
        background: #fff;
        display: flex;
        justify-content: space-between;
        .product_in_footer_left{
            display: flex;
            align-items: center;
            position: relative;
            img{
                width: 38px;
                height: 38px;
            }
            span{
                width: 18px;
                height: 18px;
                opacity: 1;
                background: rgba(228, 65, 68, 1);
                border: 1px solid rgba(255, 255, 255, 1);
                box-sizing: border-box;
                text-align: center;
                line-height: 16px;
                border-radius: 50%;
                position: absolute;
                left: 30px;
                top: -8px;
                font-size: 12px;
                color: #fff;
            }
            p{
                margin: 0 4px 0 8px;
                font-size: 14px;
                color: rgba(102, 102, 102, 1);
            }
            i{
                font-size: 14px;
            }
        }
        .product_in_footer_right{
            .van-button{
                height: 38px;
                width: 130px;
                border-radius: 6px;
            }
        }
    }

}

.product_sku_wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    .product_sku_top{
        padding: 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
            font-size: 16px;
            color: rgba(51, 51, 51, 1);
            line-height: 24px;
            font-weight: bold;
        }
        i{
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
    }
    .product_sku_content{
        width: 100%;
        padding: 0 16px 16px;
        box-sizing: border-box;
        flex: 1;
        overflow: auto;
        .field_item{
            width: 100%;
            margin-bottom: 8px;
            .field_name{
                margin-bottom: 8px;
                font-size: 12px;
                color: rgba(102, 102, 102, 1);
                line-height: 18px;
            }
            .field_value{
                width: 100%;
                span{
                    display: inline-block;
                    margin: 0 8px 8px 0;
                    line-height: 20px;
                    border-radius: 4px;
                    background: rgba(255, 255, 255, 1);
                    border: 1px solid rgba(217, 217, 217, 1);
                    box-sizing: border-box;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 1);
                    padding: 0 8px;
                    &.active{
                        background: rgba(25, 144, 255, 0.16);
                        border: 1px solid rgba(25, 144, 255, 1);
                        color: rgba(25, 144, 255, 1);
                    }
                }
            }
        }
    }
    .product_sku_bottom{
        padding: 8px 16px 8px 8px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.08);
        display: flex;
        p{
            height: 36px;
            line-height: 18px;
            color: rgba(102, 102, 102, 1);
            font-size: 12px;
            padding-right: 15px;
            box-sizing: border-box;
            flex: 1;
        }
        .van-button{
            font-size: 14px;
            height: 32px;
            border-radius: 6px;
            width: 120px;
            min-width: 120px;
            i{
                margin-right: 4px;
            }
        }
    }
}

.select_product_wrap{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .select_product_top{
        width: 100%;
        height: 48px;
        line-height: 48px;
        text-align: center;
        padding: 0 16px;
        box-sizing: border-box;
        position: relative;
        font-weight: bold;
        font-size: 16px;
        color: rgba(34, 34, 34, 1);
        span{
            position: absolute;
            right: 16px;
            top: 0;
            line-height: 48px;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
            font-weight: 400;
            i{
                margin-right: 4px;
            }
        }
    }
    .select_product_content{
        width: 100%;
        padding: 0 16px 16px;
        box-sizing: border-box;
        height: calc(100% - 48px);
        overflow: auto;
        ul{
            width: 100%;
            li{
                width: 100%;
                padding: 4px 8px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                border-radius: 6px;
                background: rgba(247, 248, 250, 1);
                margin-bottom: 4px;
                p{
                    width: calc(100% - 36px);
                    font-size: 14px;
                    color: rgba(102, 102, 102, 1);
                    line-height: 22px;
                }
                i{
                    font-size: 16px;
                    margin-left: 12px;
                    color: rgba(191, 191, 191, 1);
                }
            }
        }
    }
}

</style>